/*
 *  Bootstrap Nice Select Portuguese (Portugal) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['pt-PT'] = localisation.locales['pt'] = {
    formatSearch() {
        return "Procurando...";
    },
    formatHelpForTagging() {
        return "Para criar tags próprias, foque o campo de entrada e pressione 'Enter' ou ',' ou 'Barra de espaço' para adicioná-lo à lista";
    }
}

export default localisation;